// extracted by mini-css-extract-plugin
export default {"msgM":"dbd3624bcb"};